module.exports = __webpack_public_path__ + "static/media/RA-AP0005B.6e6203d9.png";